import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { AutoComplete } from 'primereact/autocomplete';

import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import { ModelOfProductSubgroup } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListProductSubgroupController } from '../../controllers/ProductSubgroups/ListProductSubgroupsController';
import { useFormCreateProductSubgroups } from '../../controllers/ProductSubgroups/CreateProductSubgroupsController';
import { useListProductGroupController } from 'src/controllers/ProductGroups/ListProductGroupsController';

interface filteredFieldProps {
	label: string;
	value?: string;
}

const ProductSubgroupsList: React.FC = () => {
	const { getProductSubgroupListController, handleProductSubgroupListController } =
		useListProductSubgroupController();
	const { getProductGroupListController } = useListProductGroupController();
	const { getProductSubgroupFormController, handleProductSubgroupFormController } = useFormCreateProductSubgroups();
	const [valueGroup, setValueGroup] = useState('');
	const [registerFinished, setRegisterFinished] = useState(false);
	const [filteredGroup, setFilteredGroup] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);

	const groups = getProductGroupListController.ProductGroupData.map(Group => {
		return { label: Group.DESCRICAO, value: Group.ID };
	});

	const searchGroups = (event: any) => {
		let filteredGroups;
		if (!event.query.trim().length) {
			filteredGroups = [...groups];
		} else {
			filteredGroups = groups.filter(Group => {
				return Group.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}

		setFilteredGroup(filteredGroups);
	};

	useEffect(() => {
		if (getProductSubgroupFormController.ProductSubgroupResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (
			getProductSubgroupFormController.ProductSubgroupEditedResponse?.status === 200 &&
			!getProductSubgroupFormController.ProductSubgroupResponse
		) {
			setRegisterFinished(false);
			setValueGroup('');
		}
	}, [
		getProductSubgroupFormController.ProductSubgroupResponse,
		getProductSubgroupFormController.ProductSubgroupEditedResponse,
	]);

	if (getProductSubgroupListController.loading) {
		return <LoadingScreen />;
	}

	const actionBodyTemplate = (ProductSubgroup: ModelOfProductSubgroup) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-pencil'
					className='p-button-rounded p-button-text p-button-success p-mr-2'
					onClick={() => handleProductSubgroupListController.openEditDialog(ProductSubgroup)}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => handleProductSubgroupListController.openDeleteDialog(ProductSubgroup)}
				/>
			</React.Fragment>
		);
	};

	const editProductSubgroupDialogFooter = (
		<React.Fragment>
			<Button
				label='Cancelar'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleProductSubgroupListController.closeEditDialog}
			/>
			<Button
				type='submit'
				label='Salvar'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getProductSubgroupListController.formik.handleSubmit();
				}}
			/>
		</React.Fragment>
	);

	const deleteProductSubgroupDialogFooter = (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleProductSubgroupListController.closeDeleteDialog}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getProductSubgroupListController.selectedProductSubgroup &&
						handleProductSubgroupListController.removeProductSubgroup(
							getProductSubgroupListController.selectedProductSubgroup,
						);
				}}
			/>
		</React.Fragment>
	);

	const rightProductSubgroupToolbar = () => {
		return (
			<>
				<label htmlFor='grupo'>Grupo de Produto</label>
				<AutoComplete
					disabled={registerFinished}
					id='grupo'
					value={valueGroup}
					field='label'
					placeholder='Buscar...'
					onChange={e => {
						setValueGroup(e.value);
						getProductSubgroupFormController.formik.setFieldValue(
							'AX_GRUPO',
							filteredGroup.find(Group => {
								return valueGroup.toLowerCase() === Group.label.toLowerCase();
							})?.value || '',
						);
					}}
					onSelect={e => {
						setValueGroup(e.value.label);
						getProductSubgroupFormController.formik.setFieldValue('AX_GRUPO', e.value.value);
					}}
					suggestions={filteredGroup}
					completeMethod={searchGroups}
					dropdown
					dropdownMode='current'
					minLength={2}
					delay={0}
				/>
			</>
		);
	};

	const leftProductSubgroupToolbar = () => {
		return (
			<Link to='/ProductSubgroupForm'>
				<Button label='Cadastrar subgrupo de produto' icon='pi pi-plus' className='p-button-success p-mr-2' />
			</Link>
		);
	};

	return (
		<div>
			<Toast ref={getProductSubgroupListController.toast} />
			<div className='p-card p-p-4 datatable-container'>
				<Toolbar
					className='p-mb-4'
					left={leftProductSubgroupToolbar}
					//	right={ rightProductSubgroupToolbar }
				>

				</Toolbar>

				<DataTable
					className='p-datatable-sm'
					dataKey='ID'
					rowHover
					scrollable
					scrollHeight="70vh"
					value={getProductSubgroupListController.ProductSubgroupData}>
					<Column field='DESCGRUPO' header='GRUPO'></Column>

					<Column field='DESCSUBGRUPO' header='SUBGRUPO'></Column>

					<Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
				</DataTable>
			</div>

			<Dialog
				className='p-fluid'
				style={{ width: '450px' }}
				visible={getProductSubgroupListController.editDialog}
				onHide={handleProductSubgroupListController.closeEditDialog}
				onShow={() =>
					getProductSubgroupListController.formik.setFieldValue(
						'DESCRICAO',
						getProductSubgroupListController.selectedProductSubgroup?.DESCRICAO,
					)
				}
				footer={editProductSubgroupDialogFooter}
				header={`Editar subgrupo ${getProductSubgroupListController.selectedProductSubgroup?.DESCRICAO}`}
				modal>
				<div className='p-field'>
					<label htmlFor='description'>Nome</label>
					<InputText
						id='name'
						type='text'
						value={getProductSubgroupListController.formik.values.DESCRICAO}
						onChange={getProductSubgroupListController.formik.handleChange('DESCRICAO')}
						required
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getProductSubgroupListController.formik.touched.DESCRICAO &&
								getProductSubgroupListController.formik.errors.DESCRICAO,
							'popup-form-inactive': !(
								getProductSubgroupListController.formik.touched.DESCRICAO &&
								getProductSubgroupListController.formik.errors.DESCRICAO
							),
						})}>
						{getProductSubgroupListController.formik.errors.DESCRICAO}
					</div>
				</div>
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				visible={getProductSubgroupListController.deleteDialog}
				onHide={handleProductSubgroupListController.closeDeleteDialog}
				footer={deleteProductSubgroupDialogFooter}
				header='Remover subgrupo'
				modal>
				<div className='confirmation-content'>
					<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
					{getProductSubgroupListController.selectedProductSubgroup && (
						<span>
							Você tem certeza que deseja deletar o subgrupo{' '}
							<b>{getProductSubgroupListController.selectedProductSubgroup.DESCRICAO}</b>?
						</span>
					)}
				</div>
			</Dialog>
		</div>
	);
};

export default ProductSubgroupsList;
